module.exports = __webpack_public_path__ + "static/media/slide5.6e02ff96.png";